import * as React from 'react';
import { SharedSlideout } from '@payscale/payscale-shared-ui/lib/Slideout';
import { EligibilityProrationTabs } from 'typings/enums';
import { EligibilityRules } from 'nomst/Components/EligibilityProration/eligibilityRules';
import { ProrationRules } from 'nomst/Components/EligibilityProration/prorationRules';
import { EligibilityProrationRuleView } from 'nomst/Stores/Budget/eligibilityProrationRuleView';
import './eligibilityProrationSettings.scss';
import { observer } from 'mobx-react';

interface IEligibilityProrationSettingsProps {
    eligibilityProrationRuleView: EligibilityProrationRuleView;
    isOpen: boolean;
    closeSlideout: () => void;
}

@observer
export class EligibilityProrationSettings
    extends React.Component<IEligibilityProrationSettingsProps, {}> {

    constructor(props: IEligibilityProrationSettingsProps) {
        super(props);

        this.handleCloseSlideout = this.handleCloseSlideout.bind(this);
        this.handleEligibilityTabClick = this.handleEligibilityTabClick.bind(this);
        this.handleProrationTabClick = this.handleProrationTabClick.bind(this);
    }

    render(): React.ReactNode {
        const { eligibilityProrationRuleView } = this.props;
        const eligibilityTabClass = 'nomst-eligibility-proration-settings__tab '
            + 'nomst-eligibility-proration-settings__tab--eligibility tab';
        const prorationTabClass = 'eligibility-proration-settings__tab '
            + 'nomst-eligibility-proration-settings__tab--proration tab';
        const eligibilityActiveClass = eligibilityProrationRuleView.currentRuleTab === EligibilityProrationTabs.EligibilityRule ? 'active' : '';
        const prorationActiveClass = eligibilityProrationRuleView.currentRuleTab === EligibilityProrationTabs.ProrationRule ? 'active' : '';

        return (
            <SharedSlideout
                isOpen={this.props.isOpen}
                panelClassName="nomst-eligibility-proration-settings"
                handleCloseSlideout={this.handleCloseSlideout}
                useCloseButton={true}
            >
                <div className="nomst-eligibility-proration-settings__content">
                    <h2 className="nomst-eligibility-proration-settings__title">
                        Configure Rules
                    </h2>
                    <nav className="nomst-eligibility-proration-settings__tabs tabs">
                        <button
                            className={`pxl-link ${eligibilityTabClass} ${eligibilityActiveClass}`}
                            onClick={this.handleEligibilityTabClick}
                        >
                            Eligibility
                        </button>
                        <button
                            className={`pxl-link ${prorationTabClass} ${prorationActiveClass}`}
                            onClick={this.handleProrationTabClick}
                        >
                            Proration
                        </button>
                    </nav>
                    {this.renderTabContent()}
                </div>
            </SharedSlideout>
        );
    }

    private renderTabContent(): React.ReactNode {
        const { eligibilityProrationRuleView, isOpen } = this.props;
        if (!isOpen) {
            return null;
        }

        if (eligibilityProrationRuleView.currentRuleTab === EligibilityProrationTabs.EligibilityRule) {
            return (
                <EligibilityRules
                    eligibilityRuleTabView={eligibilityProrationRuleView.eligibilityRuleTabView}
                />
            );
        }

        return (
            <ProrationRules
                prorationRuleTabView={eligibilityProrationRuleView.prorationRuleTabView}
            />
        );
    }

    private handleCloseSlideout(): void {
        this.props.closeSlideout();
    }

    private handleEligibilityTabClick(): void {
        this.props.eligibilityProrationRuleView.changeRuleTabGlobal(EligibilityProrationTabs.EligibilityRule);
    }

    private handleProrationTabClick(): void {
        this.props.eligibilityProrationRuleView.changeRuleTabGlobal(EligibilityProrationTabs.ProrationRule);
    }
}

export default { EligibilityProrationSettings };